module.exports = __webpack_public_path__ + "static/media/Parking-Inactive-Dark.0e673c00.svg";